<script>
	import Score from './Score.svelte';
	import ScoreResult from './ScoreResult.svelte';

	let Pulse= 0;
	let BP = 0;
	let Temp = 0;
	let Resp = 0;
	let Sat = 0;
	
	let convert = false;
	let oxygen = false;

	function activetab() {
		let a = this.querySelector('input[type=radio]').value;
		let value = Math.abs(a);

		parent = Array.from(this.parentNode.children);
		parent.forEach(function (e,i) {
			e.classList.remove("active");
			if (e.classList.contains("last")) { 
				e.style["border-color"]= "black";
			} else {
				e.style["border-color"] = "rgba(172, 184, 184, 0.3)";
			}	
		});
	    this.classList.add("active");	
		if (value === 3) {
			this.style["border"] = "2px solid rgba(193,39,45,1)";
		
		} else if (value === 2) {
			this.style["border"] = "2px solid rgb(239, 135, 9)";

		} else if (value === 1) {
			this.style["border"] = "2px solid rgb(181, 181, 15)";

		} else {
			this.style["border"] = "2px solid rgba(0,146,69,1)";
		}
	
	};

</script>

<section>
	
	<div class="scoreSheet">	
		<div>
			<div class="topBar">
				<div><p>PULSE</p></div>
				<div><p class="subP">Score</p></div>
			</div>
			<div class="vitals grid-six">
				<label on:click={activetab}><input type=radio bind:group={Pulse} value={-3}>&le; 40</label>
				<label on:click={activetab}><input type=radio bind:group={Pulse} value={-1}>41-50</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={Pulse} value={0}>51-90</label>
				<label on:click={activetab}><input type=radio bind:group={Pulse} value={1}>91-110</label>
				<label on:click={activetab}><input type=radio bind:group={Pulse} value={2}>111-130</label>
				<label on:click={activetab}><input type=radio bind:group={Pulse} value={3}>&ge; 131</label>
				<label class="last">{Math.abs(Pulse)}</label>
			</div>
		</div>
		<div>
			<div>
				<p>BLOOD PRESSURE</p>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type="radio" bind:group={BP} value={-3}>&le; 90</label>
				<label on:click={activetab}><input type="radio" bind:group={BP} value={-2}>91-100</label>
				<label on:click={activetab}><input type="radio" bind:group={BP} value={-1}>101-110</label>
				<label class="active" on:click={activetab}><input type="radio" bind:group={BP} value={0}>111-219</label>
				<label on:click={activetab}><input type="radio" bind:group={BP} value={3}>&ge; 220</label>
				<label class="last">{Math.abs(BP)}</label>

			</div>
		</div>	
		<div>			
			{#if convert == false}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;C)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={Temp} value={-3}>&le; 35</label>
				<label on:click={activetab}><input type=radio bind:group={Temp} value={-1}>35.1-36</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={Temp} value={0}>36.1-38</label>
				<label on:click={activetab}><input type=radio bind:group={Temp} value={1}>38.1-39</label>
				<label on:click={activetab}><input type=radio bind:group={Temp} value={2}>&ge; 39</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{Math.abs(Temp)}</label>
			</div>
			{:else}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;F)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={Temp} value={-3}>&le; 95</label>
				<label on:click={activetab}><input type=radio bind:group={Temp} value={-1}>95.1-96.8</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={Temp} value={0}>96.7-100.4</label>
				<label on:click={activetab}><input type=radio bind:group={Temp} value={1}>100.5-102.2</label>
				<label on:click={activetab}><input type=radio bind:group={Temp} value={2}>&ge; 102.3</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{Math.abs(Temp)}</label>
			</div>
			{/if}
		</div>	
		<div>
			<div><p>RESPIRATORY RATE</p></div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={Resp} value={-3}>&le; 8</label>
				<label on:click={activetab}><input type=radio bind:group={Resp} value={-1}>9-11</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={Resp} value={0}>12-20</label>
				<label on:click={activetab}><input type=radio bind:group={Resp} value={2}>21-24</label>
				<label on:click={activetab}><input type=radio bind:group={Resp} value={3}>&ge;25</label>
				<label class="last">{Math.abs(Resp)}</label>
			</div>
		</div>	
		<div>
			<div class="topTemp">
			<div><p>OXYGEN SATURATION</p></div>
			<label class="convert"><input type="checkbox" bind:checked={oxygen}/>  COPD</label>
			</div>
			{#if oxygen == false}
			<div class="vitals grid-four">
				<label on:click={activetab}><input type=radio bind:group={Sat} value={-3}>&le; 86</label>
				<label on:click={activetab}><input type=radio bind:group={Sat} value={-2}>86-88</label>
				<label on:click={activetab}><input type=radio bind:group={Sat} value={-1}>88-92</label>
				<label class="active"  on:click={activetab}><input type=radio bind:group={Sat} value={0}>&ge; 93</label>
				<label class="last">{Math.abs(Sat)}</label>
			</div>
			{:else}
			<div class="vitals grid-four">
				<label on:click={activetab}><input type=radio bind:group={Sat} value={-3}>&le; 83</label>
				<label on:click={activetab}><input type=radio bind:group={Sat} value={-2}>84-85</label>
				<label on:click={activetab}><input type=radio bind:group={Sat} value={-1}>86-87</label>
				<label class="active"  on:click={activetab}><input type=radio bind:group={Sat} value={0}>&ge; 88</label>
				<label class="last">{Math.abs(Sat)}</label>
			</div>
			{/if}
			<div>
	
		<div class="grid-two">
			<Score {Pulse} {BP} {Temp} {Resp} {Sat}/>
			<ScoreResult/>
		</div>	
		<div><h5>Adapted from NEWS-2 (National Emergency Warning Score v.2)</h5></div>		
	</div>
</section>

<style>
	
	section {
		font-family: bebas-neue-by-fontfabric,sans-serif;
		font-weight: 700;
		font-style: normal;
		justify-content: center;
		align-items: center;
		color: rgba(0, 0, 0, 0.976);
		overflow: hidden;
		padding: 2rem 1rem 2rem 1rem;	

	}

	section h3 {
		font-size: 2rem;
		text-align: center;
	}

	section h5 {
		color: #00afaa;
	}

	p {
		text-align: left;
		font-size: 1rem;
		color:rgba(65, 64, 64, 1);
		margin: 0.4rem;
	}

	.topBar {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}

	.topTemp {
		display: grid;
		grid-template-columns: 1fr 0.3fr;
	}
	.subP {
		text-align: right;
		font-size: 0.7rem;
	}
	
	.scoreSheet {
		width: 100%;
		margin-left: auto;
		margin-right: auto;
	}
	.vitals {
		border: 2px solid rgb(0, 0, 0);
		padding: 5px;
		text-align: center;
	}

	label {
		font-family: expressway,sans-serif;
		font-weight: 400;
		font-style: normal;
		display: inline-block;
		text-align: center;
		font-size: 0.8rem;
		border: 2px solid rgba(172, 184, 184, 0.3);
		border-radius: 0.2rem;
		padding: 0.08rem;
		background: transparent;
	}
	
	.convert {
		font-family: bebas-neue-by-fontfabric,sans-serif;
		font-weight: 700;
		font-style: normal;
		justify-content: center;
		align-items: center;
		margin: 0.4rem;
		font-size: 1rem;
		text-align: right;
		border: none;
		color: #00afaa;
	}

	.active {
		border: 2px solid rgba(0,146,69,1);
	}
	.last {
		border: 1px solid black;
	}
	
	input[type="radio"] {
		display: none;
		}

	.grid-two {
		display: grid;
		grid-template-columns: 1fr 1fr 60px;
	}
	
	.grid-six {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 60px;
	}
	.grid-five {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 60px;
	}

	.grid-four {
		display: grid;
 		grid-template-columns: 1fr 1fr 1fr 1fr 60px;
	}

	.smaller-label {
		font-size: 0.6rem;
	}

</style>